import {components} from 'react-select';

import styled from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {ThemeForwardingWrapper} from './SelectThemeForwarding.v2';

const ForwardedWrapper = ({forwardTheme, ...props}) => {
  return (
    <ThemeForwardingWrapper
      Component={components.Menu}
      forwardTheme={forwardTheme}
      {...props}
    />
  );
};

export const SelectMenuV2 = styled(ForwardedWrapper)`
  && {
    border-radius: ${ms(8)};
    background-color: ${getColor('background1')};
    overflow: hidden;
  }

  & .react-select__menu-list {
    padding-top: 0;
    padding-bottom: 0;
  }
`;
